import React from "react";
import { Typography, Box } from "@mui/material";

const KvkkModal = () => {
  return (
    <Box
      sx={{
        // p: 3,
        // bgcolor: "background.paper",
        // borderRadius: 2,
        // boxShadow: 3,
        // maxHeight: "80vh",
        // overflowY: "auto",
      }}
    >
      <Typography variant="h6" gutterBottom>
        AÇIK RIZA METNİ
      </Typography>
      <Typography variant="body1" paragraph>
        07/04/2016 tarih ve 29677 sayılı Resmî Gazete’de yayımlanan 6698 sayılı
        Kişisel Verilerin Korunması Kanunu’nun  uyarınca, kişisel verileriniz;
        veri sorumlusu olarak Lst Yazılım Elektronik Ve İletişim Teknolojileri
        İnşaat Turizm Ticaret Anonim Şirketi ("LST Yazılım") tarafından aşağıda
        açıklanan kapsamda toplanacak ve işlenebilecektir. LST Yazılım’a bu
        doğrultuda verdiğiniz açık rızanızı her zaman geri alma hakkına
        sahipsiniz.
      </Typography>
      <Typography variant="body1" paragraph>
        <b>İşlenen Kişisel Verileriniz:</b> Kimlik Bilgileri (isim, soyisim,
        doğum tarihi, TCKN, meslek bilgisi gibi), İletişim Bilgileri (dahili
        telefon, cep telefonu numarası, e-posta, adres gibi), Mesleki Deneyim
        Verileri (Özgeçmiş bilgisi, eğitim ve sertifika bilgileri vb.), Özel
        Nitelikli Kişisel Veri, Eğitim Verisi, İş Deneyimi Verisi, Görsel ve
        İşitsel Veri, Web sitesi/Uygulama kullanım verileri, Müşteri İşlem
        Bilgileri (üye numarası, işlem numarası, destek ve talep bilgisi gibi
        veriler, kullanım hizmet türü gibi veriler), İşlem Güvenliği Verileri
        (İnternet sitesi giriş-çıkış bilgileri, kullanıcı adı-parola bilgileri
        vb.) ve diğer ilgili veriler.
      </Typography>
      <Typography variant="body1" paragraph>
        <b>Kişisel Verileriniz Hangi Amaçlarla İşlenmektedir:</b> Kişisel
        Verilerim açık rızamın varlığı halinde, istihdam yaratmak ve işe alım
        sürecinize destek vermek, size iş bulmak, işveren müşterilerimize de
        doğru adaya ulaşabilmeleri amacıyla, paylaştığınız kişisel
        verilerinizden yararlanarak işveren müşteri ilanları ile eşleştirme
        yapmak, öz geçmişinizi başvuru yaptığınız veya özgeçmişinizin bütün
        işverenlere görünebilmesi seçeneğini seçtiğiniz takdirde, talep eden
        İşveren Müşteriye aktarmak, istihdam hizmetimizi sağlayabilmek adına
        özgeçmişinizde yer alan özel nitelikli kişisel verileriniz de dahil
        olmak üzere çeşitli amaçlarla işlenebilecektir.
      </Typography>
      <Typography variant="body1" paragraph>
        <b>Kişisel Verilerinizin Aktarılma Amaçları ve Aktarıldığı Taraflar:</b>{" "}
        Açık rızamın varlığı halinde, kişisel verilerim yukarıda belirtilen
        işleme amaçları ile yurt içi ve yurt dışı paydaşlara aktarılabilir.
      </Typography>
    </Box>
  );
};

export default KvkkModal;
